import {
  FileResponse,
  ImageBatchWellDropScore,
  ScoreClient,
  WellDropScore,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';

class ScoreService extends BaseService {
  async GetWellDropScoresByGroupName(groupName: string): Promise<WellDropScore[]> {
    const client: ScoreClient = ModelFactory(ScoreClient);
    return await client.getWellDropScoresByGroupName(groupName);
  }

  async getImageBatchWellDropScoresByImageBatchId(
    imageBatchId: number,
  ): Promise<ImageBatchWellDropScore[]> {
    const client: ScoreClient = ModelFactory(ScoreClient);
    return await client.getImageBatchWellDropScoresByImageBatchId(imageBatchId);
  }

  async saveAutoScoreThresholdResetValue(
    value: number,
    imageBatchId: number,
    autoScoreImageTypeId: number,
  ): Promise<boolean> {
    const client: ScoreClient = ModelFactory(ScoreClient);
    return await client.saveAutoScoreThresholdResetValue(
      value,
      imageBatchId,
      autoScoreImageTypeId,
    );
  }

  async downloadScoreLogs(fileName: string): Promise<FileResponse> {
    const client: ScoreClient = ModelFactory(ScoreClient, false, true);
    return await client.downloadScoreLogs(fileName);
  }
}

export { ScoreService };
